import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";

function SpecijalistickeObavjestenje() {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <Bredcom />

      <section className="specialist-notice-section">
        <div className="container">
          <div className="specialist-notice-hero">
            <div className="specialist-notice-eyebrow">
              {t("specialistNotice.eyebrow")}
            </div>

            <h1>{t("specialistNotice.title")}</h1>
            <p className="specialist-notice-lead">
              {t("specialistNotice.lead")}
            </p>

            <div className="specialist-notice-box">
              <div className="specialist-notice-icon">
                <i className="fas fa-info-circle" />
              </div>
              <div>
                <h2>{t("specialistNotice.boxTitle")}</h2>
                <p>{t("specialistNotice.boxText")}</p>
              </div>
            </div>

            <div className="specialist-notice-grid">
              <div className="specialist-notice-card">
                <span>{t("specialistNotice.step1Label")}</span>
                <h3>{t("specialistNotice.step1Title")}</h3>
                <p>{t("specialistNotice.step1Text")}</p>
              </div>

              <div className="specialist-notice-card">
                <span>{t("specialistNotice.step2Label")}</span>
                <h3>{t("specialistNotice.step2Title")}</h3>
                <p>{t("specialistNotice.step2Text")}</p>
              </div>
            </div>

            <div className="specialist-notice-master-links">
              <div>
                <h2>{t("specialistNotice.chooseTitle")}</h2>
                <p>{t("specialistNotice.chooseText")}</p>
              </div>

              <div className="specialist-notice-actions">
                <Link to="/poslovna-ekonomija" className="specialist-notice-btn primary">
                  {t("specialistNotice.businessEconomics")}
                  <i className="fas fa-arrow-right" />
                </Link>
                <Link
                  to="/ekonomija-javnog-sektora"
                  className="specialist-notice-btn secondary"
                >
                  {t("specialistNotice.publicEconomics")}
                  <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </div>

            <p className="specialist-notice-disclaimer">
              {t("specialistNotice.disclaimer")}
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default SpecijalistickeObavjestenje;
